import { IFarmMapRepository } from '../../domain/repositories/IFarmMap.repository'
import { FarmMapDto } from '../../domain/dtos/FarmMap.dto'
import { FarmMapClient } from './FarmMapClient.abstract'
import { FarmMapSchema } from '../schemas/FarmMap.schema'
import { HttpStatusCodeEnum } from '../../../@shared/domain/enums/HttpStatusCode.enum'

export class FarmMapRepository implements IFarmMapRepository {
	private readonly _endpoint = '/v1/Gis'

	constructor(private readonly _httpClient: FarmMapClient) {}

	async getByFarmId(farmId: string): Promise<FarmMapDto> {
		const response = await this._httpClient.get(
			`${this._endpoint}/GetAllMapsByFazendaId?fazendaId=${farmId}`,
		)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			throw new Error('Não foi possível buscar os mapas da fazenda.')
		}

		return FarmMapSchema.parse(response.data)
	}

	async getByMeasurementId(measurementId: string): Promise<FarmMapDto> {
		const response = await this._httpClient.get(
			`${this._endpoint}/GetFazendaEPlantiosMapByMedicaoId?medicaoId=${measurementId}`,
		)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			throw new Error('Não foi possível buscar os mapas da fazenda.')
		}

		return FarmMapSchema.parse(response.data)
	}
}
